<script>
import { Bar, mixins  } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['data', 'options', 'height', 'chartData'],
  created: function() {   console.log('dashboard.vue', 'created'); },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
